import React, { useState, useEffect, useRef } from 'react';
import './feedback.css';

const SkillBar = ({ skill, percentage, url,infos }) => {
  const [width, setWidth] = useState(0);
  const skillRef = useRef(null);
  const animationRef = useRef(null);
  const startTimeRef = useRef(null);
  const feed = {
    display: 'flex',
    justifyContent: 'center'
}

  
  useEffect(() => {
    const currentSkillRef = skillRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          // Démarrer l'animation
          startTimeRef.current = performance.now();
          const duration = 800; // 0.8 secondes - plus rapide
          
          const animate = (timestamp) => {
            if (!startTimeRef.current) startTimeRef.current = timestamp;
            const elapsed = timestamp - startTimeRef.current;
            const progress = Math.min(elapsed / duration, 1);
            const currentWidth = Math.floor(progress * percentage);
            
            setWidth(currentWidth);
            
            if (progress < 1) {
              animationRef.current = requestAnimationFrame(animate);
            }
          };
          
          animationRef.current = requestAnimationFrame(animate);
        } else {
          // Réinitialiser
          cancelAnimationFrame(animationRef.current);
          setWidth(0);
          startTimeRef.current = null;
        }
      },
      { threshold: 0.5 }
    );

    if (currentSkillRef) observer.observe(currentSkillRef);

    return () => {
      if (currentSkillRef) observer.unobserve(currentSkillRef);
      cancelAnimationFrame(animationRef.current);
    };
  }, [percentage]);

  return (
    <div className="skill-item" ref={skillRef}>
      <div className="skill-header">
        <div className="feed-icon" style={feed}> <img src={url} alt="" /> </div>
        <div className='infos'> "{infos}"  </div>
        <div className="skill-info">
          <span className="skill-name">{skill}</span>
          <span className="skill-percentage">{width}%</span>
        </div>
      </div>
      <div className="feed-bar-container">
        <div 
          className="feed-bar" 
          style={{ width: `${width}%` }}
          role="progressbar"
          aria-valuenow={width}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
};
const Feedback = () => {
  const skills = [
    { name: ' Happy Clients', level: 95, url:'/assets/img-feedback/icons8-apply-48.png', infos:'How many clients are satisfied about our services' },
    { name: 'Returning Clients', level: 95, url:'/assets/img-feedback/icons8-ookla-speedtest-50 (1).png' ,infos:'How many clients are satisfied about our services and choose to come back for more services'},
    { name: 'Customer Testimonials & Referrals', level: 90 , url:'/assets/img-feedback/icons8-arrow-51 (1).png',infos:'How many clients are satisfied about our services and choose to share to other people'},
   
  ];

  return (
    <section className="skills-section">
      <h2> Feedbacks</h2>
      <div className="skills-container">
        {skills.map((skill) => (
          <SkillBar 
            key={skill.name} 
            skill={skill.name} 
            percentage={skill.level} 
            url={skill.url}
            infos = {skill.infos}
          />
        ))}
      </div>
    </section>
  );
};

export default Feedback;